import { customerAccountModule } from '@agos/customer-account'
import { customerCheckoutModule } from '@agos/customer-checkout'
import { customerCmsModule } from '@agos/customer-cms'
import { customerConsentModule } from '@agos/customer-consent'
import { customerMenuModule } from '@agos/customer-menu'
import { customerNotificationsModule } from '@agos/customer-notifications'

import type { CustomerBanner, CustomerModule, CustomerOrderPlacedSurface, CustomerRoute } from './module-contract'

/**
 * Every feature module the shell composes.
 *
 * Adding one here must move its pages in `FRONTEND-STATUS.md` in the same commit, and
 * `route-diff.test.ts` fails the build while this table and `docs/INVENTORY/customer-routes.json`
 * disagree — the same arrangement the manager shell has had since §12.
 */
export const customerModules: CustomerModule[] = [
  customerMenuModule as unknown as CustomerModule,
  customerCheckoutModule as unknown as CustomerModule,
  customerAccountModule as unknown as CustomerModule,
  customerCmsModule as unknown as CustomerModule,
  customerNotificationsModule as unknown as CustomerModule,
  customerConsentModule as unknown as CustomerModule,
]

export function composedRoutes(): CustomerRoute[] {
  return customerModules.flatMap((module) => module.routes ?? [])
}

/** The paths whose module asked for the footer. */
export function footerRoutes(): Set<string> {
  return new Set(composedRoutes().filter((route) => route.showsFooter === true).map((route) => route.path))
}

/**
 * The banners, in the order legacy's `App.tsx` mounts them: install prompt, cookie consent, push. They
 * are fixed-position surfaces that can overlap, so the order is not cosmetic.
 */
export function composedBanners(): CustomerBanner[] {
  return customerModules.flatMap((module) => module.banners ?? [])
}

/** What the success page draws under *Ďakujeme!* (§9.779), in module order. */
export function composedOrderPlaced(): CustomerOrderPlacedSurface[] {
  return customerModules.flatMap((module) => module.orderPlaced ?? [])
}
